import db from './index.js'

/**
 * Completely clears all data from IndexedDB
 * This checks for all known table names in the database schema
 * and explicitly clears each one to ensure complete cleanup
 */
export async function clearDatabase() {
    console.log('Clearing all IndexedDB tables...')

    try {
        // Get all table names from the database
        const tableNames = db.tables.map((table) => table.name)
        console.log('Clearing tables:', tableNames.join(', '))

        // Clear each table individually
        for (const tableName of tableNames) {
            if (db[tableName] && typeof db[tableName].clear === 'function') {
                await db[tableName].clear()
                console.log(`Cleared table: ${tableName}`)
            }
        }

        // Force a complete deletion of the database as a fallback
        // This helps ensure even tables we might have missed are cleared
        await db.delete()
        console.log('Database completely deleted')

        // Reopen the database with empty tables
        await db.open()
        console.log('Database reopened with empty tables')

        return true
    } catch (error) {
        console.error('Error clearing database:', error)
        return false
    }
}
